var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"notifications-indicator"},[_c('b-img',{attrs:{"src":require('../assets/img/notifications.svg')}}),(_vm.notifications > 0)?_c('div',{staticClass:"badge"},[_vm._v(" "+_vm._s(_vm.number)+" ")]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }